import script from "./FavoriteVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoriteVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./FavoriteVouchersPage.vue?vue&type=style&index=0&id=70397a2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70397a2d"]])

export default __exports__